﻿import { defineComponent } from "/Scripts/vue.esm-browser.js";
import Enterprise from "./Enterprise.js";
import StoresToC from "./StoresB2C.js";
import StoresToB from "./StoresB2B.js";
import StoresToE from "./StoresB2E.js";
import StoresToBToC from "./StoresBBC.js";
const html = String.raw;

export default defineComponent({
    name: "FooterBody",

    props: {
        webSite: {
            type: String,
            required: true,
        },
        bbcSn: {
            type: Number,
            required: false,
        },
    },
    components: {
        Enterprise,
        StoresToC,
        StoresToB,
        StoresToE,
        StoresToBToC,
    },
    setup() {
        return {};
    },
    template: html`
        <div class="footer_body">
            <enterprise v-if="webSite!=='bbc'" :web-site="webSite"></enterprise>
            <stores-to-c v-if="webSite=='b2c'" :web-site="webSite"></stores-to-c>
            <stores-to-b v-if="webSite=='b2b'" :web-site="webSite"></stores-to-b>
            <stores-to-e v-if="webSite=='b2e'" :web-site="webSite"></stores-to-e>
            <stores-to-b-to-c v-if="webSite=='bbc'" :web-site="webSite" :bbc-sn="bbcSn"></stores-to-b-to-c>
            <div v-if="webSite=='bbc'" style="font-size: 13px;">Copyright © 2025百威旅遊版權所有</div>
        </div>
    `,
});
